import React from 'react';
import { IconEye, IconSmile } from '../basics/icons';
import { InputMeta, ModifiedInput } from '.';
import cn from 'classnames';
import './input.scss';
import './input-password.scss';
import { InputWrapper } from './InputWrapper';

export interface InputPasswordProps extends Omit<ModifiedInput, 'type'> {
  isLoading?: boolean;
  onChange?: (value: string) => void;
  meta?: InputMeta;
  value?: string;
  prepend?: React.ReactNode;
  append?: React.ReactNode;
}

export const InputPassword: React.FC<InputPasswordProps> = ({
  isLoading,
  onChange,
  className,
  meta,
  prepend,
  append,
  ...unused
}) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <InputWrapper {...meta}>
      {prepend && <div className="input-el--prepend">{prepend}</div>}
      <div className={cn('input-password-field', { 'input-password-field--visible': visible })}>
        <div className={cn({ 'input-loading': isLoading }, 'w-full')}>
          <input
            type={visible ? 'text' : 'password'}
            className={cn('input-default', className)}
            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
              onChange?.(event.currentTarget.value);
            }}
            {...unused}
          />
          {isLoading && (
            <div className="loader">
              <IconSmile spinning={true} />
            </div>
          )}
        </div>
        <button type="button" className="input-password-field__toggle" onClick={() => setVisible(v => !v)}>
          <IconEye />
        </button>
      </div>
      {append && <div className="input-el--append">{append}</div>}
    </InputWrapper>
  );
};
